import { COMMAND_ACTION, Command } from "../../types/command.d";

export const setCommands = (commands: Command[]) => {
  return {
    type: COMMAND_ACTION.SET_COMMANDS,
    payload: commands,
  };
};
